export const channels = {
  MUSIC: 0,
  SFX: 1,
}